import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    loadingStatus: false,
    personTypeItems: [],
  },
  getters: {
    loadingStatus (state) {
      return state.loadingStatus
    },
    personTypeItems (state) {
      return state.personTypeItems
    }
  },
  mutations: {
    SET_LOADING_STATUS (state, payload) {
      state.loadingStatus = payload
    },
    SET_PERSON_TYPE_ITEMS (state, payload) {
      state.personTypeItems = payload
    }
  },
  actions: {
    loadPersonTypeItems (context) {
      console.log('actions loadPersonTypeItems')
      context.commit('SET_LOADING_STATUS', true)
      Vue.axios.get(`${config.serverURI}/personTypes`).then((response) => {
        // console.log('personTypeItems', response.data)
        context.commit('SET_PERSON_TYPE_ITEMS', response.data)
      }).catch((error) => {
        console.log(error)
        context.commit('SET_LOADING_STATUS', false)
        context.dispatch('snackbarOnLoadFail', error)
      })
    },
    loadItems ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/personTypes`, payload)
    },
    create ({ commit, dispatch }, payload) {
      console.log('-> create', payload)
      return Vue.axios.post(`${config.serverURI}/personTypes`, payload)
    },
    update ({ commit, dispatch }, payload) {
      console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/personTypes/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      console.log('-> delete', payload)
      return Vue.axios.delete(`${config.serverURI}/personTypes/${payload.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common/personType.js